import { StyledInfoBox } from './showpad-delay-info-box.style';
import { Text } from '../../ui-components/text/text';
import { InfoIcon } from '../icons-library/info';
import theme from '../../style/theme';

type ShowpadDelayInfoBoxProps = {
    text: string; 
    withoutPadding?: boolean;
};

export const ShowpadDelayInfoBox = (props: ShowpadDelayInfoBoxProps) => {
    return (
        <div>
            <StyledInfoBox withoutPadding={props.withoutPadding}>
                <InfoIcon
                    width="2rem"
                    height="2rem"
                    stroke={theme.palette.darkGray}
                />
                <div style={{ 'width': 'fit-content' }}>
                    <Text
                        fontSize='footerSmall'
                        fontStyle='italic'
                    >
                        {props.text}
                    </Text>
                </div>
            </StyledInfoBox>
        </div>
    );
};

